export const mapDocumentationData = (unMappedData) => {
  if (!unMappedData) return;
  return unMappedData.reduce((previous, datum) => {
    const mappedDatum = mapDocumentationJsonApiDatum(datum);
    return mappedDatum && mappedDatum.uuid
      ? {
          ...previous,
          [mappedDatum.uuid]: mappedDatum,
        }
      : previous;
  }, {});
};

export const mapDocumentationDatum = (datum) => {
  const {
    doc_url,
    url,
    path,
    uuid,
    title,
    field_api_id,
    field_deprecated,
    field_api_version,
    product,
    tour,
    field_bot_enabled,
    field_bot_url,
  } = datum;
  const alias = path ? path.alias : null;
  return {
    url,
    docUrl: doc_url,
    uuid,
    title,
    api_id: field_api_id,
    alias,
    product,
    deprecated: field_deprecated,
    version: field_api_version,
    tour: tour,
    bot_enabled: field_bot_enabled,
    bot_url: field_bot_url,
  };
};

export const mapDocumentationJsonApiDatum = (datum) => {
  const { path, title, field_api_version } = datum.attributes;
  const alias = path ? path.alias : null;
  return {
    uuid: datum.id,
    title,
    alias,
    version: field_api_version,
  };
};
